import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { Toaster } from "react-hot-toast";

import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import VeelgesteldeVragen from "./pages/VeelgesteldeVragen";
import TrailerDetail from "./pages/TrailerDetail";
import ReservationSuccess from "./pages/ReservationSuccess";
import Sidebar from "./components/Sidebar";
import Reservations from "./pages/Reservations";
import Trailers from "./pages/Trailers";
import Checkout from "./pages/Checkout";
import CheckoutPage from "./pages/CheckoutPage";
import Checkin from "./pages/Checkin";
import DepositSettlement from "./pages/DepositSettlement";
import ProtectedRoute from "./components/ProtectedRoute";
import DamageUpload from "./pages/DamageUpload";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Archive from "./pages/Archive";
import AuditLog from "./pages/AuditLog";
import AdminCheckouts from "./pages/AdminCheckouts";
import AdminCheckoutDetail from "./pages/AdminCheckoutDetail";
import AdminCheckoutStart from "./pages/AdminCheckoutStart";
import AdminCheckins from "./pages/AdminCheckins";
import AdminCheckinDetail from "./pages/AdminCheckinDetail";
import AdminCheckinStart from "./pages/AdminCheckinStart";
import TrailerQr from "./pages/TrailerQr";
import AdminSettlements from "./pages/AdminSettlements";
import AdminSettlementDetail from "./pages/AdminSettlementDetail";

const looksLikeJwt = (token) => typeof token === "string" && token.split(".").length === 3;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    const savedToken = localStorage.getItem("token");

    if (savedUser && looksLikeJwt(savedToken)) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
      }
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    }

    setLoading(false);
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.clear();
    setUser(null);
  };

  if (loading) {
    return <div className="loading-state">Laden...</div>;
  }

  const adminShell = (page) => {
    if (!user) return <Navigate to="/login" />;

    return (
      <div className="app-shell">
        <Sidebar onLogout={handleLogout} />
        <main className="main-area">{page}</main>
      </div>
    );
  };

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<Home user={user} onLogout={handleLogout} />} />
        <Route path="/contact" element={<Contact user={user} onLogout={handleLogout} />} />
        <Route path="/veelgestelde-vragen" element={<VeelgesteldeVragen user={user} onLogout={handleLogout} />} />
        <Route path="/privacybeleid" element={<PrivacyPolicy user={user} onLogout={handleLogout} />} />
        <Route path="/algemene-voorwaarden" element={<TermsAndConditions user={user} onLogout={handleLogout} />} />
        <Route path="/aanbod/trailers/:id" element={<TrailerDetail user={user} onLogout={handleLogout} />} />
        <Route path="/reservatie-succes" element={<ReservationSuccess />} />
        <Route path="/checkout/:reservationId" element={<CheckoutPage />} />
        <Route path="/trailer-checkout/:qrToken" element={<CheckoutPage />} />
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/dashboard" element={adminShell(<Dashboard />)} />
        <Route path="/trailers" element={adminShell(<Trailers />)} />
        <Route path="/admin/trailers/:id/qr" element={adminShell(<TrailerQr />)} />
        <Route path="/reservations" element={adminShell(<Reservations />)} />
        <Route path="/admin/checkouts" element={adminShell(<AdminCheckouts />)} />
        <Route path="/admin/checkouts/reservation/:reservationId/start" element={adminShell(<AdminCheckoutStart />)} />
        <Route path="/admin/checkouts/:id" element={adminShell(<AdminCheckoutDetail />)} />
        <Route path="/admin/checkins" element={adminShell(<AdminCheckins />)} />
        <Route path="/admin/checkins/reservation/:reservationId/start" element={adminShell(<AdminCheckinStart />)} />
        <Route path="/admin/checkins/:id" element={adminShell(<AdminCheckinDetail />)} />
        <Route path="/admin/settlements" element={adminShell(<AdminSettlements />)} />
        <Route path="/admin/settlements/:id" element={adminShell(<AdminSettlementDetail />)} />
        <Route path="/checkout" element={adminShell(<Checkout />)} />
        <Route path="/checkin" element={adminShell(<Checkin />)} />
        <Route path="/deposit" element={adminShell(<DepositSettlement />)} />
        <Route path="/damage" element={adminShell(<DamageUpload />)} />
        <Route path="/customers" element={adminShell(<Customers />)} />
        <Route path="/customers/:id" element={adminShell(<CustomerDetail />)} />
        <Route path="/archive" element={adminShell(<Archive />)} />
        <Route path="/audit" element={adminShell(<AuditLog />)} />
        <Route path="/admin" element={adminShell(<ProtectedRoute user={user} role="Admin"><Dashboard /></ProtectedRoute>)} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
